<template>
  <section class="take-loan sf-pv-l">
    <div class="take-loan__wrapper">
      <sf-button
        :url="registrationStepRedirectUrl"
        class="secondary take-loan__button">
        {{ $t('layout.borrow-btn') }}
      </sf-button>
    </div>
  </section>
</template>

<script>
import { WEB_ROUTES } from '~/app/shared/utils/web-config';

export default {
  computed: {
    registrationStepRedirectUrl() {
      return this.localePath(WEB_ROUTES.REGISTRATION_STEP_1);
    },
  },
};
</script>

<style lang="scss" scoped>
.take-loan {
  flex-grow: 1;

  @include tablet {
    margin-bottom: -40px;
  }

  &__wrapper {
    position: relative;

    @include mobile {
      display: flex;
      justify-content: center;
    }

    @include desktop {
      padding-right: 440px;
    }
  }

  &__button {
    min-width: 280px;
  }
}
</style>
